/* Component Dependencies */
var confirmationMessagePrint = require('templates/confirmationMessage.hbs');
var confirmationMessagePrintTemplate = require('templates/confirmationMessage-print.hbs');
var confirmationMessageChangeConfirmationTemplate = require('templates/confirmationMessage-changeConfirmation.hbs');
var confirmationMessageCancelReservationChanges = require('templates/confirmationMessage-cancelReservationChanges.hbs');
var confirmationMessageConfirmCancellation = require('templates/confirmationMessage-confirmCancellation.hbs');
var confirmationMessageChangeConfirmationSuccess = require('templates/confirmationMessage-changeConfirmationSuccess.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

PubSub.register(AriesComponent.extend({
  type: 'confirmationMessage',
  subscribe: {
    'REFRESH_CONFIRMATION_MESSAGE_UPDATE': 'componentUpdate',
    'SHOWHIDE': 'showHideTile',
    'HIDESUCCESS': 'hideSuccessTile'
    },
  template: {
    'confirmationMessage': confirmationMessagePrint,
    'confirmationMessage-print': confirmationMessagePrintTemplate,
    'confirmationMessage-changeConfirmation' : confirmationMessageChangeConfirmationTemplate,
    'confirmationMessage-cancelReservationChanges': confirmationMessageCancelReservationChanges,
    'confirmationMessage-confirmCancellation': confirmationMessageConfirmCancellation,
    'confirmationMessage-changeConfirmationSuccess': confirmationMessageChangeConfirmationSuccess
  },
  bindEvents: function() {
    this.$el.find('.use-term-link').attr('target', 'new');
  },
  componentUpdate: function(context){
    this.refresh(context);
    },
  showHideTile: function (data) {
  	if(data === true){
  		$(".tile-confirmation-section").removeClass('is-hidden');
   }
 },
   
  hideSuccessTile: function (data) {
   	if(data === true){
  		$(".js-success-msg").addClass('is-hidden');
    }
  }
  
}));
